import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const C = {
  h1: (p) => <h3 className="text-base font-semibold text-slate-900 mb-2" {...p} />,
  h2: (p) => <h4 className="text-sm font-semibold text-slate-900 mt-3 mb-1" {...p} />,
  h3: (p) => <h5 className="text-sm font-semibold text-slate-900 mt-2 mb-1" {...p} />,
  p: (p) => <p className="mb-2" {...p} />,
  ul: (p) => <ul className="list-disc pl-5 mb-2 space-y-0.5" {...p} />,
  ol: (p) => <ol className="list-decimal pl-5 mb-2 space-y-0.5" {...p} />,
  a: (p) => <a className="underline" target="_blank" rel="noopener noreferrer" {...p} />,
};

export const TosMarkdown = ({ text, className = "", testid }) => (
  <div className={`leading-relaxed ${className}`} data-testid={testid}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={C}>{text}</ReactMarkdown>
  </div>
);
